// extracted by mini-css-extract-plugin
export default {"drawer":"V2x0ZBFRekAj5VDqmRNC","subTitle":"aYBPjFRt0u0toGtRIuhg"};